module.exports = __webpack_public_path__ + "img/V.df2eb2e0.png";